// extracted by mini-css-extract-plugin
export default {"editButton":"advanceSalaryInstallment_editButton__PWLX+","TableBody":"advanceSalaryInstallment_TableBody__tmlOt"};